/**
 * Horas de acesso à live por plano, editáveis no admin ("Tempo de acesso"). A lista de
 * benefícios dos planos (`tradutors/assine.ts`) traz os marcadores `{horasPlus}` e
 * `{horasGold}`, trocados aqui pelos números do backend (`v1/live/getAccessHours`).
 *
 * Sem resposta, ou com valor fora do que o admin aceita (inteiro de 1 a 720), ficam os
 * padrões do backend: 48 para o Plus e 72 para o Gold.
 */

export type HorasDaLive = { plus: number; gold: number };

export const HORAS_DA_LIVE_PADRAO: HorasDaLive = { plus: 48, gold: 72 };

function horasValidas(valor: unknown, padrao: number): number {
  const numero = Number(valor);
  return Number.isInteger(numero) && numero >= 1 && numero <= 720 ? numero : padrao;
}

export function horasDaLive(dados: unknown): HorasDaLive {
  const horas = (dados ?? {}) as { plus?: unknown; gold?: unknown };
  return {
    plus: horasValidas(horas.plus, HORAS_DA_LIVE_PADRAO.plus),
    gold: horasValidas(horas.gold, HORAS_DA_LIVE_PADRAO.gold),
  };
}

export function comHorasDaLive(texto: string, horas: HorasDaLive): string {
  return texto
    .replace(/\{horasPlus\}/g, String(horas.plus))
    .replace(/\{horasGold\}/g, String(horas.gold));
}
